import React from "react";

const TermsAndCondition = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div
        className="site-breadcrumb"
        style={{ backgroundImage: "url(/assets/img/breadcrumb/01.png)" }}
      >
        <div className="container">
          <h2 className="breadcrumb-title">Terms & Conditions</h2>
        </div>
      </div>

      {/* Terms Content */}
      <main className="main">
        <div className="terms-area py-120">
          <div className="container">
            <div className="terms-content">
              <h3>Our Performance</h3>
              <p>
                We strive to provide reliable and high-quality services to all
                users. Our platform is carefully designed to deliver a smooth,
                secure, and valuable learning experience. We continuously work
                to improve our services and maintain high standards.
              </p>
            </div>

            <div className="terms-content">
              <h3>Cookies</h3>
              <p>
                We use cookies to improve user experience, analyze website
                traffic, and enhance platform functionality. By using our
                services, you consent to the use of cookies.
              </p>
            </div>

            <div className="terms-content">
              <h3>Payments</h3>
              <p>
                All payments on Kademy are processed securely. Course prices,
                subscription fees, and payment terms may change from time to
                time without prior notice.
              </p>
            </div>

            <div className="terms-content">
              <h3>Refund Policy</h3>
              <p>
                Refunds are provided only when eligibility conditions are met.
                Users are advised to review course details carefully before
                making a purchase.
              </p>
            </div>

            <div className="terms-content">
              <h3>Hyperlinking to Our Content</h3>
              <p>
                You may link to our website provided the link does not mislead
                users, falsely imply sponsorship, or damage the reputation of
                Kademy.
              </p>
            </div>

            <div className="terms-content">
              <h3>Disclaimer</h3>
              <p>
                Kademy is not responsible for any losses, interruptions, or
                technical issues that occur beyond our reasonable control.
                Content is provided for educational purposes only.
              </p>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default TermsAndCondition;
